// 调班管理 - 调班管理
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

export const shiftColumn = [
  key('学生姓名', 'studentName', tableColumnsWidth.type2, { fixed: 'left' }),
  key('年级班级', 'gradeClassName', tableColumnsWidth.type9),
  key('家长手机', 'parentPhone', tableColumnsWidth.type8),
  slot('学校', 'schoolName', tableColumnsWidth.type6),
  key('学期', 'termName', tableColumnsWidth.type5),

  slot('课程分类', 'classType', tableColumnsWidth.type9, {
    align: 'center'
  }),
  slot('原课程名称', 'oldClassroomName', tableColumnsWidth.type6),
  key('原上课时间', 'oldTimeDesc', tableColumnsWidth.type6),
  key('课程金额（元）', 'oldClassroomFee', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('实收金额（元）', 'courseOrdFee', tableColumnsWidth.type9, {
    align: 'center'
  }),
  slot('报名状态', 'enrollStatus', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('调班课程名称', 'newProductName', tableColumnsWidth.type6),
  key('调班上课时间', 'newTimeDesc', tableColumnsWidth.type4),
  slot('班级名称', 'newClassName', tableColumnsWidth.type6),
  key('调班课程金额（元）', 'newClassroomFee', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('课时', 'newClassroomTime', tableColumnsWidth.type2, {
    align: 'center'
  }),
  slot('调班状态', 'convertStatus', tableColumnsWidth.type2, {
    align: 'center'
  }),
  key('调班时间', 'createTime', tableColumnsWidth.type4),
  slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
]
